import React from 'react';
import './partners.css';

const Partners = () => {
    return (
        <section className="partners">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-3 col-md-12 text">
                            <div className="heading">
                                <h3>Who Will You <br/>Learn With?</h3>
                            </div>
                            <p>You can list your partners or instructors's brands here to show off your sites reputation and students
                                can trust you more.
                            </p>
                            <button type="button">View all partners</button>
                        </div>
                        <div className="col-lg-9 col-md-12">
                            <div className="row">
                                <div className="col-lg-2 col-md-3 col-sm-6 col-xs-6">
                                    <img src="images/client-logo-01.jpg" className="img-fluid"/>
                                </div>
                                <div className="col-lg-2 col-md-3 col-sm-6 col-xs-6">
                                    <img src="images/client-logo-02.jpg" className="img-fluid"/>
                                </div>
                                <div className="col-lg-2 col-md-3 col-sm-6 col-xs-6">
                                    <img src="images/client-logo-03.jpg" className="img-fluid"/>
                                </div>
                                <div className="col-lg-2 col-md-3 col-sm-6 col-xs-6">
                                    <img src="images/client-logo-04.jpg" className="img-fluid"/>
                                </div>
                                <div className="col-lg-2 col-md-3 col-sm-6 col-xs-6">
                                    <img src="images/client-logo-05.jpg" className="img-fluid"/>
                                </div>
                                <div className="col-lg-2 col-md-3 col-sm-6 col-xs-6">
                                    <img src="images/client-logo-06.jpg" className="img-fluid"/>
                                </div>
                                <div className="col-lg-2 col-md-3 col-sm-6 col-xs-6">
                                    <img src="images/client-logo-07.jpg" className="img-fluid"/>
                                </div>
                                <div className="col-lg-2 col-md-3 col-sm-6 col-xs-6">
                                    <img src="images/client-logo-08.jpg" className="img-fluid"/>
                                </div>
                                <div className="col-lg-2 col-md-3 col-sm-6 col-xs-6">
                                    <img src="images/client-logo-09.jpg" className="img-fluid"/>
                                </div>
                                <div className="col-lg-2 col-md-3 col-sm-6 col-xs-6">
                                    <img src="images/client-logo-10.jpg" className="img-fluid"/>
                                </div>
                                <div className="col-lg-2 col-md-3 col-sm-6 col-xs-6">
                                    <img src="images/client-logo-11.jpg" className="img-fluid"/>
                                </div>
                                <div className="col-lg-2 col-md-3 col-sm-6 col-xs-6">
                                    <img src="images/client-logo-12.jpg" className="img-fluid"/>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
    )
}
export default Partners;